









































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '../../../../lib/abpbase'
import {
	GetMachineModelList,
	InsertMachineModel,
	UpdateMachineModelById,
	DeleteMachineModel
} from '../../../../api/specialDictionary'

@Component
export default class Repair extends AbpBase {
	@Prop({type: Boolean, default: false}) value: boolean;
	@Prop() data: any;
	addDialogTitle = ''
	cancel(){
		this.addModalShow = false
	}
	dialogForm: any = {
		changJ : this.data.changJ

	}
	dialogFormVisible = false
	addModalShow = false
	dialogFormLabelWidth = '100px'
	tableLoading = false
	tableData = []
	page = 1
	tableTotalSize = 0
	util = Util
	get dialogTitle() {
		return this.data.changJ + "型号"
	}
	add() {
		this.addDialogTitle = "新增型号"
		this.dialogForm = {
			changJ : this.data.changJ
		}
		this.addModalShow = true
	}

	edit(row: any){
		this.addDialogTitle = "编辑型号"
		this.dialogForm = Object.assign({}, row)
		this.addModalShow = true
	}

	del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteMachineModel({Id: row.id})
			this.getData()
		}).catch(() => {

		});
	}

	//新增编辑窗口确认
	async confirm() {
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.addDialogTitle === "新增型号"){
					this.dialogForm.changJID = this.data.id
					let res = await InsertMachineModel(this.dialogForm)
				} else {
					let res = await UpdateMachineModelById(this.dialogForm)
				}
				this.getData()
			}
		})



	}

	created() {
		this.getData()
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	addModalVisibleChange(value: boolean) {
		if (!value) {
			this.addModalShow = false
		}
	}

	async getData() {
		this.tableLoading = true
		let res = await GetMachineModelList({
			ChangJID: this.data.id,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	pageChange(val: any){
		this.page = val
		this.getData()
	}

	rules = {
		changJ: [{required: true, message: '请输入内容', trigger: 'blur'}],
		model: [{required: true, message: '请输入内容', trigger: 'blur'}],
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/factory/parts/repair.vue